<style>

h3{
  text-align: center;
}

.space{
  margin: 20px;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

<h3>What is your age preference for meeting other people?</h3>
  
<div class="space slider">
  <RangeSlider id="price" min="{18}" max="{120}" pushy range float bind:values="{agePreference}" springValues="{ { stiffness: 0.25, damping: 0.9 } }"></RangeSlider>
</div>

<div class="space">{agePreference[0]} - {agePreference[1]}</div>

{/if}

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import RangeSlider from "svelte-range-slider-pips";

import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";

export let show = false;
export let me = null;

let agePreference = [18,120];


$:{
  if (me) set();
}


function set() {
  agePreference = JSON.parse( JSON.stringify( me.agePreference ) );
}


function check() {
  try {
  } catch (e) {
    console.log("error:", e);
  }
}


export const save = async () => {
  if (agePreference[0] != me.agePreference[0] || agePreference[1] != me.agePreference[1]) {
    me.agePreference = agePreference;
    await profile.updateMe( { updateShare: true } );
  }
}


</script>